module.exports = __webpack_public_path__ + "static/14-d6995ea36e9c1703dd3e9949a8eeff40.jpg";